import { RArray } from "../../collections";
export class HolidayService {
    constructor(params) {
        this.rpcService = params.rpcService;
    }
    async getHolidays(restaurantId) {
        const holidays = await this.rpcService.rpc("GetHolidaysRequest", {
            restaurantId: restaurantId.value,
        });
        return new RArray(holidays);
    }
}
